<template>
  <popover-right v-model="isVisible" class="custome-add-style" width="70%" :closed="cancel" :completeClose="cancel">
    <h1 class="add-title">新增客户</h1>
    <el-form :model="info" :rules="rules" ref="customeBaseInfo">
      <div class="btn-container">
        <el-button class="global-btn info" @click="cancel">取消</el-button>
        <el-button class="global-btn primary" @click="save">保存</el-button>
      </div>
      <div class="form-list-info c-detail-add-group">
        <h1 class="section-title">基本资料</h1>
        <div class="base-col base-col-2">
          <div class="item">
            <span class="label label-required">客户姓名：</span>
            <el-form-item class="lebel-con label-con-style-1" prop="name" ref="name">
              <el-input placeholder="请输入客户姓名" v-model="info.name" @change="initContactName"/>
            </el-form-item>
          </div>
          <div class="item">
            <span class="label">客户等级
              <el-tooltip placement="bottom-start" class="info-tips" popper-class="custome-tooltip">
                <div slot="content">
                  <p class="level-desc">客户等级划分：</p>
                  <p class="level-desc" v-for="levelName in Object.keys(levels)" :key="levelName">{{levelName}}：{{levels[levelName]}}</p>
                </div>
                <i class="iconfont iconwenti_yiwen"></i>
              </el-tooltip>
              ：</span>
            <el-form-item class="lebel-con label-con-style-2" prop="level" style="margin-right:10px;" ref="level">
              <el-select v-model="info.level" placeholder="请选择客户等级">
                <el-option v-for="(level, key) in options.customer_levels" :key="key" :label="level" :value="key"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="item">
            <span class="label label-required">联系人：</span>
            <el-form-item class="lebel-con label-con-style-1" prop="contact_name" ref="contact_name">
              <el-input placeholder="请输入联系人" v-model="info.contact_name" />
            </el-form-item>
          </div>
          <div class="item">
            <span class="label label-required">联系号码：</span>
            <p class="result result-ellipse">{{tel}}</p>
          </div>
          <div class="item">
            <span class="label label-required">来源渠道：</span>
            <el-form-item class="lebel-con label-con-style-1" prop="channel" ref="channel">
              <el-select v-model="info.channel" placeholder="请选择来源渠道" @change="handleChangeChannel">
                <el-option v-for="(channel, key) in options.customer_offline_channels" :key="key" :label="channel" :value="key"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div style="width: 100%;">
            <div class="item" v-if="info.channel == 2">
              <span class="label"></span>
              <el-form-item class="lebel-con label-con-style-1" prop="sub_channel_text" ref="sub_channel_text">
                <el-input v-model="info.sub_channel_text" placeholder="请输入转介人信息" maxlength="20"></el-input>
              </el-form-item>
            </div>
            <div class="item" v-else-if="info.channel == 7 || info.channel == 11 || info.channel == 12">
              <span class="label"></span>
              <el-form-item class="lebel-con label-con-style-1" prop="sub_channel_id" ref="sub_channel_id">
                <el-select v-model="info.sub_channel_id" placeholder="请选择">
                  <el-option v-for="(channel, key) in getChannels" :key="key" :label="channel" :value="key"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="item">
            <span class="label">客户当前地：</span>
            <el-form-item class="lebel-con" prop="location" ref="location">
              <el-radio-group v-model="info.location">
                <el-radio :label="key" size="medium" :key="key" v-for="(location, key) in options.customer_locations">{{location}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="item">
            <span class="label">购房资质：</span>
            <el-form-item class="lebel-con" prop="qualifications" ref="qualifications">
              <el-radio-group v-model="info.qualifications">
                <el-radio :label="key" size="medium" v-for="(quality, key) in options.customer_qualifications" :key="key">{{quality}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </div>
      </div>

      <div class="form-list-info c-detail-add-group">
        <h1 class="section-title">需求信息</h1>
        <div class="base-col base-col-2">
          <div class="item item-input-top">
            <span class="label">购房类型：</span>
            <el-form-item class="lebel-con custome-level" prop="require_type" ref="require_type">
              <el-select v-model="info.require_type" placeholder="请选择购房类型">
                <el-option v-for="(value, key) in options.require_type" :key="key" :label="value" :value="key"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="item item-flexall">
            <span class="label">意向区域：</span>
            <el-form-item class="lebel-con label-night" prop="city_area_id" ref="city_area_id">
              <area-auto-complete class="user-mutiple-area" v-model="info.city_area_id" :multiple="true" placeholder="请选择意向区域（最多三项）" :allowCreate="true"></area-auto-complete>
            </el-form-item>
          </div>
          <div class="item item-flexall" v-if="info.require_type == 1">
            <span class="label">意向项目：</span>
            <el-form-item class="lebel-con label-night" prop="intention_project_ids" ref="intention_project_ids">
              <project-auto-complete class="user-mutiple-area" :isAll="true"  placeholder="请输入意向项目（最多三项）" v-model="info.intention_project_ids" :multiple="true" :allowCreate="true"></project-auto-complete>
            </el-form-item>
          </div>
          <div class="item item-flexall" v-if="info.require_type == 2">
            <span class="label">意向小区：</span>
            <el-form-item class="lebel-con label-night" prop="esf_community" ref="esf_community">
              <el-input placeholder="请输入意向小区（最多三项），用;隔开" v-model="info.esf_community" maxlength="50" clearable  />
            </el-form-item>
          </div>
          <div class="item item-flexall" v-if="info.require_type == 2">
            <span class="label">意向二手房：</span>
            <el-form-item class="lebel-con label-night" prop="esf_address" ref="esf_address">
              <el-input placeholder="请输入意向二手房楼栋、房号" v-model="info.esf_address" maxlength="50" clearable  />
            </el-form-item>
          </div>
          <div class="item item-input-top">
            <span class="label">面积：</span>
            <div class="lebel-con">
              <el-form-item prop="area" ref="area">
                <el-input placeholder="最小" style="width:80px;" v-model="info.area_min" />
                <span class="range">—</span>
                <el-input placeholder="最大" style="width:80px;" v-model="info.area_max" />
                <span class="range">㎡</span>
              </el-form-item>
            </div>
          </div>
          <div class="item item-input-top">
            <span class="label">价格：</span>
            <div class="lebel-con">
              <el-form-item prop="price" ref="price" class="rang-1">
                <el-input placeholder="最小" style="width:80px;" v-model="info.price_min" />
                <span class="range range-1">—</span>
                <el-input placeholder="最大" style="width:80px;" v-model="info.price_max" />
              </el-form-item>
              <span class="range">万元</span>
            </div>
          </div>
          <div class="item item-input-top">
            <span class="label">意向楼层：</span>
            <div class="lebel-con">
              <el-form-item prop="floor" ref="floor">
                <el-input placeholder="最小" style="width:80px;" v-model="info.floor_min" />
                <span class="range range-1">—</span>
                <el-input placeholder="最大" style="width:80px;" v-model="info.floor_max" />
                <span class="range">层</span>
              </el-form-item>
            </div>
          </div>
          <div class="item item-input-top">
            <span class="label">朝向：</span>
            <el-form-item class="lebel-con custome-level" prop="orientation" ref="orientation">
              <el-select v-model="info.orientation" placeholder="请选择朝向">
                <el-option v-for="(orientations, key) in options.orientations" :key="key" :label="orientations" :value="key"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="item item-flexall">
            <span class="label">意向户型：</span>
            <el-form-item class="lebel-con" prop="room_id" ref="room_id">
              <el-checkbox-group v-model="info.room_id">
                <el-checkbox v-for="(layout, key) in options.rooms" :label="key" :key="key" :value="key" >{{layout}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
          <div class="item item-flexall" style="padding-top: 8px;">
            <span class="label">物业类型：</span>
            <el-form-item class="lebel-con" prop="house_type" ref="house_type">
              <el-checkbox-group v-model="info.house_type">
                <el-checkbox v-for="(type, key) in options.house_types" :label="key" :key="key" :value="key" >{{type}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
          <div class="item">
            <span class="label">装修：</span>
            <el-form-item class="lebel-con" prop="decoration" ref="decoration">
              <el-checkbox-group v-model="info.decoration">
                <el-checkbox v-for="(decoration, key) in options.decorations" :label="key" :key="key" :value="key" >{{decoration}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
          <div class="item item-flexall">
            <span class="label">备注：</span>
            <el-form-item class="lebel-con custome-remark" prop="remark" ref="remark">
              <el-input type="textarea" placeholder="请输入备注" :show-word-limit="true" maxlength="300" :rows="4" v-model="info.remark" />
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>
  </popover-right>
</template>
<script>
    import PopoverRight from '@/components/popover/index';
    import {configKeys} from '@/setting/index';
    import {validateMobile, validateUserName} from '@/utils/validate';
    import {customeAdd, getLevelDesc} from '@/api/custome';
    import AreaAutoComplete from '@/components/select/AreaAutoComplete';
    import ProjectAutoComplete from '@/components/select/ProjectAutoComplete';
    import { mapState } from 'vuex';
    export default {
        name: 'CustomeAdd',
        components: {
            PopoverRight,
            AreaAutoComplete,
            ProjectAutoComplete
        },
        data () {
            return {
                isVisible: false,
                tel: '',
                info: {
                    name: '无',
                    room_id: [],
                    house_type: [],
                    decoration: [],
                    city_area_id: [],
                    intention_project_ids: [],
                    require_type: '1',
                    esf_community: ''
                },
                options: {
                    customer_levels: {},
                    customer_offline_channels: {},
                    customer_locations: {},
                    rooms: {},
                    house_types: {},
                    decorations: {},
                    orientations: {}
                },
                rules: {
                    name: [
                        {required: true, message: '请输入客户姓名', trigger: 'blur'},
                        {min: 1, max: 20, message: '客户姓名长度在1-20之间', trigger: 'blur'}
                    ],
                    contact_name: [
                        {required: true, message: '请输入联系人姓名', trigger: 'blur'},
                        {min: 1, max: 20, message: '联系人姓名长度在1-20之间', trigger: 'blur'}
                    ],
                    channel: [
                        {required: true, message: '请选择来源渠道', trigger: 'change'}
                    ],
                    contact_tel: [
                        {validator: validateMobile, name: '联系电话', trigger: 'blur'}
                    ],
                    area: [
                        {validator: this.validateArea, trigger: 'blur'}
                    ],
                    price: [
                        {validator: this.validatePrice, trigger: 'blur'}
                    ],
                    floor: [
                        {validator: this.validateFloor, trigger: 'blur'}
                    ]
                },
                levels: {},
                concats: []
            }
        },
        computed: {
            getChannels () {
                const chan = this.info.channel;
                if (chan == 7) return this.options.sub_channel_7;
                else if (chan == 11) return this.options.sub_channel_11;
                else if (chan == 12) return this.options.sub_channel_12;
                else return [];
            }
        },
        async created () {
            const keys = ['customer_levels', configKeys.customer_offline_channels, configKeys.customer_locations,
                configKeys.customer_qualifications, configKeys.rooms, configKeys.house_types, configKeys.decorations, configKeys.orientations, 'require_type', 'sub_channel_7', 'sub_channel_11', 'sub_channel_12'];
            this.options = await this.$store.dispatch('initConfig', keys);
            this.getLevelAll();
        },
        methods: {
            open (tel) {
                this.tel = tel;
                this.isVisible = true;
            },
            cancel () {
                this.isVisible = false;
                this.$parent.initCustome && this.$parent.initCustome();
                this.info= {
                    room_id: [],
                    house_type: [],
                    decoration: [],
                    city_area_id: [],
                    intention_project_ids: [],
                    require_type: '1'
                }
                this.$nextTick(_ => {
                    this.$refs?.customeBaseInfo?.clearValidate?.();
                })
            },
            handleChangeChannel () {
                this.$set(this.info, 'sub_channel_text', '');
                this.$set(this.info, 'sub_channel_id', '');
            },
            // 默认姓名=联系人姓名
            initContactName(){
                this.$set(this.info, 'contact_name', this.info.name)
            },
            // 面积校验
            validateArea (rule, value, callback) {
                const max = this.info['area_max'];
                const min = this.info['area_min'];
                if (!max && !min) {
                    callback();
                } else if (min && !/^([1-9][0-9]{0,5})$/.test(`${min}`)) {
                    callback(`最小面积为1-999999之间的整数类型`);
                } else if (max && !/^([1-9][0-9]{0,5})$/.test(`${max}`)) {
                    callback(`最大面积为1-999999之间的整数类型`);
                } else if (!!max && !!min && Number(max) < Number(min)) {
                    callback('最小面积不能大于最大面积');
                } else {
                    callback();
                }
            },
            // 价格校验
            validatePrice (rule, value, callback) {
                const max = this.info['price_max'];
                const min = this.info['price_min'];
                if (!max && !min) {
                    callback();
                } else if (min && !/^([1-9][0-9]{0,5})$/.test(`${min}`)) {
                    callback(`最小价格为1-999999之间的整数`);
                } else if (max && !/^([1-9][0-9]{0,5})$/.test(`${max}`)) {
                    callback(`最大价格为1-999999之间的整数`);
                }else if (!!max && !!min && Number(max) < Number(min)) {
                    callback('最小价格不能大于最大价格');
                } else {
                    callback();
                }
            },
            // 楼层校验
            validateFloor (rule, value, callback) {
                const m = this.info['floor_max'],
                    i = this.info['floor_min'];
                if (!m && !i) {
                    callback();
                    return null;
                }
                const nm = Number(m),
                    ni = Number(i);
                if (i && (!/^\d{1,2}$/.test(i) || ni <= 0)) {
                    callback(`最小楼层在1-99之间`);
                } else if (m && (!/^\d{1,2}$/.test(m) || nm <= 0)) {
                    callback(`最大楼层在1-99之间`);
                } else if (i && m && nm < ni) {
                    callback('最小楼层不能大于最大楼层');
                } else {
                    callback();
                }
            },
            // 获取所有等级描述展示
            async getLevelAll () {
                try {
                    const res = await getLevelDesc({
                        name: 'customer_level_desc'
                    });
                    this.levels = res;
                } catch (error) {
                }
            },
            // 保存客户
            save () {
                this.$refs.customeBaseInfo && this.$refs.customeBaseInfo.validate(async (valid, dom) => {
                    if (!valid) {
                        this.validateError(dom);
                        return null;
                    };
                    try {
                        const params = {...this.info};
                        ['decoration', 'house_type', 'room_id'].map(v => {
                            params[v] = params[v]?.length > 0 ? params[v].join(',') : '';
                        })
                        if (params.intention_project_ids && params.intention_project_ids.length > 0) {
                            const ids = [];
                            const names = [];
                            params.intention_project_ids.map(v => {
                                if (typeof v == 'string') {
                                    ids.push(0);
                                    names.push(v);
                                } else {
                                    ids.push(v.id);
                                    names.push(v.name);
                                }
                            })
                            params.intention_project_ids = ids.join(',');
                            params.intention_project_names = names.join(',');
                        } else {
                            params.intention_project_ids = '';
                        }
                        // 拼接意向区域
                        if (params.city_area_id && params.city_area_id.length > 0) {
                            const ids = [];
                            const names = [];
                            params.city_area_id.map(v => {
                                if (typeof v == 'string') {
                                    ids.push(0);
                                    names.push(v);
                                } else {
                                    ids.push(v.id);
                                    names.push(v.name);
                                }
                            })
                            params.city_area_id = ids.join(',');
                            params.city_area_name = names.join(',');
                        }else{
                            params.city_area_id = '';
                            params.city_area_name = '';
                        }
                        params.status = 5;
                        params.contact_tel = this.tel;
                        if (params.require_type == 1) {
                            delete params.esf_community;
                            delete params.esf_address;
                        } else if (params.require_type == 2) {
                            delete params.intention_project_ids;
                        }
                        await customeAdd(params);
                        this.$message.success('操作用户信息成功')
                        this.cancel();
                        this.$EventBus.$emit("NewYorker_refresh")
                    } catch (error) {
                        this.$message.error(error.msg || '操作失败，请重试')
                    }
                })
            },
            // 校验错误信息
            validateError (object) {
                let split = '';
                for (let i in object) {
                    let dom = this.$refs[i];
                    if (Object.prototype.toString.call(dom) !== '[object Object]') {
                        dom = dom[0];
                        split = dom.prop;
                        let index = split.indexOf('.');
                        let last = split.lastIndexOf('.');
                        this.activeName = Number(split.slice(index + 1, last));
                        break;
                    }
                    dom.$el.scrollIntoView({
                        block: 'center',
                        behavior: 'smooth'
                    })
                }
            },
        }
    }
</script>
<style lang="less">
  .add-title{
    background: #f1f4fa;
    font-size: 18px;
    line-height: 55px;
    padding: 0 20px;
    color: #333;
    font-weight: bold;
  }
  .custome-add-style{
    .c-detail-add-group{
      padding: 15px 20px 5px 20px;
    }
    .section-title{
      color: #000;
      font-size: 14px;
      margin-bottom: 6px;
      font-weight: bold;
      &:before{
        content: "";
        width: 5px;
        height: 15px;
        background: #3168ff;
        display: inline-block;
        vertical-align: -2px;
        margin-right: 8px;
        border-radius: 3px;
      }
    }
    .item .label{
      font-size: 12px !important;
    }
    .label-con-style-1{
      max-width: 220px;
    }
    .label-con-style-2{
      max-width: 150px;
    }
    .el-input__inner{
      font-size: 12px !important;
    }
    .el-radio .checkbox-label,.el-radio .el-radio__label,.el-checkbox .el-checkbox__label{
      color: #333;
      font-size: 12px;
      padding-left: 7px;
    }
    .range{
      font-size: 12px;
      display: inline-block;
      padding: 0 5px;
    }
    .rang-1{
      display: inline-block;
      padding: 0 5px;
    }
    .btn-container{
      text-align: right;
      padding: 15px 20px 0 0;
      float: right;
    }
  }
</style>
